export enum RatingDependent {
  TenderOffer = 'TenderOffer',
  Driver = 'Driver'
}
